(function () {
	'use strict';

	a3_cabin_reports.controller('ReportCtrl', ReportCtrl);
	/**
	* @memberof CabinReports
	* @ngdoc controller
	* @name ReportCtrl
	* @description 
	*  Manages the Report View
	* @ngInject
	*/
	function ReportCtrl($scope, $log, $uibModal, $timeout, $routeParams, UserFactory, FlightFactory,
		CabinReportLocalEditFactory, CabinReportLocalEditCreatorFactory, $location, SettingsMain,
		WaterUpliftActionFactory, enableWaterUpliftReporting, BarTrolleyFactory, FirstAidKitFactory, MedicalIncidentFactory,
		SpecialMealIssueFactory, IncompleteServicesIssueFactory, SupplyFactory, TravelValueSealFactory,
		CCMSCrewPositionFactory, CCMSFactory, ReportGuidFactory, TravelValueIncompleteReasonFactory, LogService,
		CrewAssessmentFactory, $route, InfoAPIService, customerIncidentQuestionIds, PaxInfoFactory, FlightOrdersFactory, GroomingCategoriesFactory) {

		// get the report id
		var reportId = $routeParams.reportId;
		var report = null;
		var user = UserFactory.getUser();
		var editingPage = SettingsMain.getEditingPage();
		$scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();

		$scope.IsCustomerIncident = IsCustomerIncident;
		$scope.enableWaterUpliftReporting = enableWaterUpliftReporting;
		$scope.updateOrderStatus = updateOrderStatus;

		$scope.flightOrdersRejectReasons = FlightOrdersFactory.getNotDeliveredReasons(); 
		$scope.clearFlightOrderFeedback = clearFlightOrderFeedback;

		function IsCustomerIncident(id) {
			return customerIncidentQuestionIds.includes(id);
		}

		var groomingCategories = GroomingCategoriesFactory.getGroomingCategories();
		$scope.hasGroomingCategories = groomingCategories.length > 0;
		
		$scope.discard = function () {
			if (report == null) {
				report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
			}
			var guid = report.ReportGuid;
			var status = report.Status;

			// delete the temp report
			CabinReportLocalEditFactory.deleteTempReport();

			//reuse guid if this was a new report
			if (status == 'pending')
				ReportGuidFactory.restoreGuid(report.ReportGuid);

			// new / edit existing / load from temp
			if (reportId.startsWith('new:')) {
				var flightId = $routeParams.flightId;
				// create a new report
				var newLocalReport = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);

				if (newLocalReport == null) {
					bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.",
						function () {
							$location.path("/");
							$scope.$apply();
						}
					);
				} else {
					// load the new report
					report = newLocalReport;
				}
			} else if (reportId == 'temp') {
				// load the report from the temp place
				report = CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp();

				if (report == null) {
					// since we could not load the temp report, delete it
					CabinReportLocalEditFactory.deleteTempReport();

					bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted",
						function () {
							$location.path("/");
							$scope.$apply();
						}
					)
				}
			} else {
				// load the report
				report = CabinReportLocalEditFactory.getCabinReportLocalEdit(reportId);
				if (report == null) {
					bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.",
						function () {
							$location.path("/");
							$scope.$apply();
						}
					)
				}
			}

			$scope.report = report;
			infoSaveOperation('discard')
		}

		$scope.state = 'report';
		$scope.logged_user_info = user.aimsId + ' - ' + user.name;
		$scope.isSecure = UserFactory.isSecure();

		// new / edit existing / load from temp
		if (reportId.startsWith('new:')) {
			var flightId = $routeParams.flightId;
			// create a new report
			var newLocalReport = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);

			if (newLocalReport == null) {
				bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.",
					function () {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			} else {
				// load the new report
				report = newLocalReport;
			}
		} else if (reportId == 'temp') {
			// load the report from the temp place
			report = CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp();
			if (report == null) {
				// since we could not load the temp report, delete it
				CabinReportLocalEditFactory.deleteTempReport();
				bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted",
					function () {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			}
		} else {
			// load the report
			report = CabinReportLocalEditFactory.getCabinReportLocalEdit(reportId);
			if (report == null) {
				bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.",
					function () {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			}
		}

		$scope.countDHC = 0;
		if (report.crew) $scope.countDHC = report.crew.filter(function (item) {
			return (item.isDHC == true);
		}).length;

		//Additional feedback
		if (report.crew) {
			var crewNeedsAdditionalFeedback = [];
			var crewMemberNeedsAdditionalFeedback = report.crew.filter(x => x.needsAdditionalFeedback);
			crewNeedsAdditionalFeedback.push(crewMemberNeedsAdditionalFeedback);

			if (crewNeedsAdditionalFeedback.length > 0) {
				var crewNeedsAdditionalFeedbackFlatten = crewNeedsAdditionalFeedback.flat();
				for (var i = 0; i < crewNeedsAdditionalFeedbackFlatten.length; i++) {
					report.CCMSCrewPositions.find(x => x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId).needsAdditionalFeedback = true;
					report.CCMSCrewPositions.find(x => x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId).AdditionalFeedback = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback;
					report.CCMSCrewPositions.find(x => x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId).AdditionalFeedbackId = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback.Id;
					report.CCMSCrewPositions.find(x => x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId).FeedbackAuthorName = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback.FeedbackAuthorName;
					report.CCMSCrewPositions.find(x => x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId).Route = report.Route;
				}
			}
		}

		// update totals and set to scope
		report.updateTotals();
		$scope.report = report;

		$scope.infosaveaction = false;


		// save the report to a temp place
		if (report.Status != 'synched')
			report.saveReportAsTemp();

		// set editing page to report
		SettingsMain.setEditingPage('report');

		if (report && report.ScheduledArrival) {
			var nowTimeStamp = moment.utc().valueOf();
			var schedullDepartureTimestamp = new Date(report.ScheduledArrival).getTime();

			$scope.isFuture = false; //nowTimeStamp < schedullDepartureTimestamp;
		}
		$scope.showCompleted = showCompleted;
		$scope.showAll = showAll;
		$scope.compressedMode = false;
		function showCompleted() {
			if (!$scope.report.BarTrolleys || $scope.report.BarTrolleys.length == 0)
				$scope.panels.bars.visible = false;

			if (!$scope.report.MedicalIncidents || !(report.FirstAidKits.length > 0 || report.MedicalIncidents.length > 0))
				$scope.panels.medical.visible = false;

			if (!$scope.report.ItemsFoundSectionHasValue)
				$scope.panels.security.visible = false;

			if (!$scope.report.SpecialMealIssues || $scope.report.SpecialMealIssues.length == 0)
				$scope.panels.special.visible = false;

			if (!$scope.report.Supplies || $scope.report.Supplies.length == 0)
				$scope.panels.supplies.visible = false;

			if (!$scope.report.TravelValueSeals || !(report.TravelValueSeals.length > 0 || report.TravelValueIncomplete || (report.TravelValueRemarks != null && report.TravelValueRemarks != '')))
				$scope.panels.travel.visible = false;

			if (!$scope.report.UMSectionHasValue)
				$scope.panels.um.visible = false;

			if ($scope.report.ActiveVariousIssues == 0)
				$scope.panels.various.visible = false;

			if (!$scope.report.WaterSectionHasValue)
				$scope.panels.water.visible = false;

			if (!($scope.report.UpgradedPassengers.length > 0))
				$scope.panels.upgd.visible = false;

			if (!($scope.report.ChangedSeats.length > 0))
				$scope.panels.changedSeats.visible = false;

			if (!($scope.report.IncompleteServices.length > 0))
				$scope.panels.incompleteServices.visible = false;

			if (!$scope.report.BoardingTimes || (report.BoardingTimesRemarks != null && report.BoardingTimesRemarks != ''))
				$scope.panels.travel.visible = false;

			if (!$scope.report.LuggageSectionHasValue)
				$scope.panels.luggage.visible = false;

			if (!$scope.report.FoundProperties || $scope.report.FoundProperties.length == 0)	
				$scope.panels.foundProperty.visible = false;

			$scope.panels.leg.open = !$scope.panels.leg.open;
			$scope.compressedMode = true;
		}



		function showAll() {
			$scope.panels.bars.visible = true;
			$scope.panels.medical.visible = true;
			//$scope.panels.security.visible = true;
			$scope.panels.special.visible = true;
			$scope.panels.supplies.visible = true;
			$scope.panels.travel.visible = true;
			$scope.panels.various.visible = true;
			$scope.panels.water.visible = true;
			$scope.panels.groundServices.visible = true;
			$scope.panels.flightOrders.visible = true;
			$scope.panels.upgd.visible = true;
			$scope.panels.changedSeats.visible = true;
			$scope.panels.incompleteServices.visible = true;
			$scope.panels.boardingTimes.visible = true;
			$scope.panels.disembarkationTimes.visible = true;
			$scope.panels.luggage.visible = true;
			$scope.panels.foundProperty.visible = true;

			$scope.panels.leg.open = !$scope.panels.leg.open;
			$scope.compressedMode = false;
		}


		$scope.panels = {
			showOnlyOne: true,
			leg: {
				visible: true,
				open: true,
				cssClass: function () {
					return report.IsValid ? 'panel-green' : 'panel-orange';
				}
			},
			info: {
				visible: true,
				open: false,
				cssClass: function () {
					return 'panel-green';
				}
			},
			ccms: {
				visible: true,
				open: false,
				cssClass: function () {
					return (!report.CCMSCrewPositionsIsValid || report.CCMSCrewPositions.length == 0) ? 'panel-orange' : 'panel-green';
				}
			},
			bars: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.BarTrolleysIsValid)
						return 'panel-orange';
					else if (report.BarTrolleys.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			medical: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.FirstAidKitsIsValid || !report.MedicalIncidentsIsValid)
						return 'panel-orange';
					else if (report.FirstAidKits.length > 0 || report.MedicalIncidents.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			// security: {
			// 	visible: true,
			// 	open: false,
			// 	cssClass: function () {
			// 		if (!report.ItemsFoundSectionIsValid)
			// 			return 'panel-orange';
			// 		else if (report.ItemsFoundSectionHasValue)
			// 			return 'panel-green';
			// 		else
			// 			return 'panel-default';
			// 	}
			// },
			special: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.SpecialMealIssuesIsValid)
						return 'panel-orange';
					else if (report.SpecialMealIssues.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			supplies: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.SuppliesIsValid)
						return 'panel-orange';
					else if (report.Supplies.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			travel: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.TravelValueSealsIsValid || !report.TravelValueIncompleteIsValid) /*!report.CashValuesIsValid)*/
						return 'panel-orange';
					else if (report.TravelValueSeals.length > 0 || report.TravelValueIncomplete || (report.TravelValueRemarks != null && report.TravelValueRemarks != ''))
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			um: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.UMSectionIsValid)
						return 'panel-orange';
					else if (report.UMSectionHasValue)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			various: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.WarningVariousIssues > 0)
						return 'panel-orange';
					else if (report.ActiveVariousIssues > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			water: {
				visible: true,
				open: false,
				cssClass: function () {
					if (!report.WaterSectionIsValid)
						return 'panel-orange';
					else if (report.WaterSectionHasValue)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			groundServices: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.GroundServicesSectionHasValue)
						return 'panel-green';
					else
						return 'panel-default';

				}
			},
			flightOrders: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.FlightOrdersSectionHasValue)
						return 'panel-green';
					else
						return 'panel-orange';
				}
			},
			upgd: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.UpgradedPassengers.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			changedSeats: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.ChangedSeats.length > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			incompleteServices: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.IncompleteServices.length > 0)
						return 'panel-green';
					else
						return 'panel-default';

				}
			},
			boardingTimes: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.FirstPaxTime && report.LastPaxTime)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			disembarkationTimes: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.FirstPaxDisembarkationTime && report.LastPaxDisembarkationTime)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			luggage: {
				visible: true,
				open: false,
				cssClass: function () {
					if (report.LuggageNumber > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			foundProperty: {
				visible: true,
				open: false,
				cssClass: function () {
					 if (!report.FoundPropertiesIsValid) return 'panel-orange';
    			     if (report.FoundProperties.length > 0) return 'panel-green';

    				 return 'panel-default';
				}
			}	
		}

		$scope.panelClicked = function (e) {
			var q = $(e.currentTarget);
			if (q.hasClass('panel-sector'))
				q = q.find('textarea');
			else
				q = q.parent('.panel-sector').find('textarea');
			q.each(function (index, item) {
				autoAdjustTextarea(item);
			});
		}
		var flight = FlightFactory.getFlightFromStorage(report.FlightId);

		if (flight == null) {
			flight = FlightFactory.getLocalFlightFromStorage(report.FlightId)
		}

		if (flight == null) {
			handleIfReport(report);
			SettingsMain.setEditingPage(null);
			$location.path("/");
		}

		if (flight != null) {
			$scope.flight = flight;
			var dateObj = new Date(flight.FlightDate);
			$scope.waterSectionRequired = (dateObj.getDate() == 1 || dateObj.getDate() == 15);
		}

		if (flight == null) {
			handleIfReport(report);
			SettingsMain.setEditingPage(null);
			$location.path("/");
		}

		if (flight != null) {
			$scope.flight = flight;
			var dateObj = new Date(flight.FlightDate);
			$scope.waterSectionRequired = (dateObj.getDate() == 1 || dateObj.getDate() == 15);
		}

		$scope.sendCustomerIncident = sendCustomerIncident;

		/**
		 * Send  application Customer Incident information
		 * @memberof ReportCtrl
		 */
		function sendCustomerIncident(description, label, photos) {

			var image = photos.length > 0 ? photos[0].PhotoData : null;
			var flightDate = new Date(flight.FlightDate);
			var flightDescription = flight.FlightNo + " " + flight.Departure + "-" + flight.Arrival + " " + (flightDate.getUTCDate() > 10 ? flightDate.getUTCDate() : "0" + flightDate.getUTCDate()) + "-" + (flightDate.getUTCMonth() > 9 ? (flightDate.getUTCMonth() + 1) : "0" + (flightDate.getUTCMonth() + 1)) + "-" + flightDate.getUTCFullYear();


			var customerIncident = { flightDescription: flightDescription, question: label, description: description, image: image };

			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgCustomerIncidentSend.html',
				controller: 'CustomerModalCtrl',
				size: 'md',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					customerIncident: function () {
						return customerIncident;
					}
				}
			});

		}

		//Clear Fields Functionality
		$scope.clearItemsFoundDescription = clearItemsFoundDescription;
		$scope.clearItemsFoundAgent = clearItemsFoundAgent;
		$scope.clearItemsFoundSignature = clearItemsFoundSignature;
		$scope.clearUMDescription = clearUMDescription;
		$scope.clearUMAgent = clearUMAgent;
		$scope.clearUMSignature = clearUMSignature;
		$scope.clearWaterRemarks = clearWaterRemarks;
		$scope.clearTravelValueRemarks = clearTravelValueRemarks;
		$scope.clearBoardingTimesRemarks = clearBoardingTimesRemarks;
		$scope.clearDisembarkationTimesRemarks = clearDisembarkationTimesRemarks;
		$scope.clearRemarks = clearRemarks;
		$scope.clearCrewRemarks = clearCrewRemarks;
		$scope.clearVariousItemRemarks = clearVariousItemRemarks;
		$scope.clearBarSealsPhotoRemarks = clearBarSealsPhotoRemarks;
		$scope.clearLuggageDescription = clearLuggageDescription;
		$scope.reportItemValueChanged = reportItemValueChanged;
		$scope.cancelClicked = cancelClicked;
		$scope.saveClicked = saveClicked;
		$scope.saveDraftClicked = saveDraftClicked;
		$scope.deleteReportClicked = deleteReportClicked;
		//update report when a report item is changed
		$scope.reportChanged = reportChanged;
		// Incomplete Travel
		// Get list of reasons
		$scope.reportTravelValueIncompleteReasons = TravelValueIncompleteReasonFactory.getReasonsFromStorage();
		$scope.plusTravelValueIncompleteRow = plusTravelValueIncompleteRow;
		$scope.minusTravelValueIncompleteRow = minusTravelValueIncompleteRow;
		$scope.reportTravelIncompleteChanged = reportTravelIncompleteChanged;
		//UMnumber
		$scope.plusUMNumber = plusUMNumber;
		$scope.minusUMNumber = minusUMNumber;
		$scope.clearUMNumber = clearUMNumber;
		$scope.waterUpliftActions = WaterUpliftActionFactory.getWaterUpliftActionsFromStorageAsStrings();
		//copy positions from previous leg, to minimize input
		//normally, ac performs several legs in a row with the same crew, each at the same position on all legs
		$scope.copyCcmsPositions = copyCcmsPositions;
		// List of ccms position of this A/C
		$scope.reportCCMSPositions = reportCCMSPositions
		//Modals
		// Bars Trolleys
		$scope.addNewBarTrolley = addNewBarTrolley;
		$scope.editBarTrolley = editBarTrolley;
		$scope.deleteBarTrolley = deleteBarTrolley;
		// Luggage Number
		$scope.plusLuggageNumber = plusLuggageNumber;
		$scope.minusLuggageNumber = minusLuggageNumber;
		$scope.clearLuggageNumber = clearLuggageNumber;
		// CCMS
		$scope.addNewCCMSCrewPosition = addNewCCMSCrewPosition;
		$scope.editCCMSCrewPosition = editCCMSCrewPosition;
		$scope.deleteCCMSCrewPosition = deleteCCMSCrewPosition;

		$scope.user = UserFactory.getUser();
		$scope.showFeedback = [];
		$scope.toggleAdditionalFeedback = function ($index) {
			$scope.showFeedback[$index] = !$scope.showFeedback[$index];
		}
		//CCMS: Show(toggle) CrewComments
		$scope.showCrewComments = function (item) {
			if (item.HasCrewComments == true && !item.CrewComments) {
				item.HasCrewComments = false;
			}
			//Clear comments
			else if (item.HasCrewComments == true) {
				bootbox.dialog({
					message: "Please confirm that you wish to clear the comments",
					title: "<strong>Attention<strong>",
					buttons: {
						cancel: {
							label: "Cancel",
							className: "btn-default",
							callback: function () { }
						},
						ok: {
							label: "Ok",
							className: "btn-warning",
							callback: function () {
								$timeout(
									function () {
										item.CrewComments = null;
										item.HasCrewComments = false;
									});
								return true;
							}
						}
					}
				});
			} else {
				item.HasCrewComments = true;
			}
		};

		//Additional Feedback: Show(toggle) Crew Comments
		$scope.showAdditionalFeedback = function (item) {
			if (item.HasAdditionalFeedbackComments == true && !item.CrewComments) {
				item.HasAdditionalFeedbackComments = false;
			}
			//Clear comments
			else
				if (item.HasAdditionalFeedbackComments == true) {
					bootbox.dialog({
						message: "Please confirm that you wish to clear the comments",
						title: "<strong>Attention<strong>",
						buttons: {
							cancel: {
								label: "Cancel",
								className: "btn-default",
								callback: function () { }
							},
							ok: {
								label: "Ok",
								className: "btn-warning",
								callback: function () {
									$timeout(
										function () {
											item.CrewComments = null;
											item.HasAdditionalFeedbackComments = false;
										});
									return true;
								}
							}
						}
					});
				} else {
					item.HasAdditionalFeedbackComments = true;
				}
		};

		// Flight Detail
		$scope.openFlightDetailModal = openFlightDetailModal;
		// First Aid Kits
		$scope.addNewFirstAidKit = addNewFirstAidKit;
		$scope.editFirstAidKit = editFirstAidKit;
		$scope.deleteFirstAidKit = deleteFirstAidKit;
		// Medical Incidents
		$scope.addNewMedicalIncident = addNewMedicalIncident;
		$scope.editMedicalIncident = editMedicalIncident;
		$scope.deleteMedicalIncident = deleteMedicalIncident;
		// Special Meals
		$scope.addNewSpecialMealIssue = addNewSpecialMealIssue;
		$scope.editSpecialMealIssue = editSpecialMealIssue;
		$scope.deleteSpecialMealIssue = deleteSpecialMealIssue;
		// Supplies
		$scope.addNewSupply = addNewSupply;
		$scope.editSupply = editSupply;
		$scope.deleteSupply = deleteSupply;
		//UPGDs
		$scope.addNewUPGD = addNewUPGD;
		$scope.editUPGD = editUPGD;
		$scope.deleteUPGD = deleteUPGD;
		//Changed seats
		$scope.addNewChangedSeat = addNewChangedSeat;
		$scope.editChangedSeat = editChangedSeat;
		$scope.deleteChangedSeat = deleteChangedSeat;
		// Travel value seal 
		$scope.addNewTravelValueSeal = addNewTravelValueSeal;
		$scope.editTravelValueSeal = editTravelValueSeal;
		$scope.deleteTravelValueSeal = deleteTravelValueSeal;
		// Incomplete in-flight Services
		$scope.addIncompleteService = addIncompleteService;
		$scope.editIncompleteService = editIncompleteService;
		$scope.deleteIncompleteService = deleteIncompleteService;
		// Attatch Photo
		$scope.attachPhotoOnVariousItem = attachPhotoOnVariousItem;
		$scope.attachPhotoOnBarTrolley = attachPhotoOnBarTrolley;
		$scope.attachPhotoOnFlightOrder = attachPhotoOnFlightOrder;

		$scope.addNewEMKFirstAidKit = addNewEMKFirstAidKit;

		// Additional Feedback
		$scope.addAdditionalFeedback = addAdditionalFeedback;

		// Found Property 
		$scope.addNewFoundProperty = addNewFoundProperty;
		$scope.editFoundProperty = editFoundProperty;
		$scope.deleteFoundProperty = deleteFoundProperty;

		//Clear functions     
		/**
		 * Clear Selected Field
		 * @memberof ReportCtrl
		 * @param {object} target the object whose field we want to clear
		 * @param {string} fieldName the field Name to clear
		 */
		function clearField(target, fieldName) {
			if (target[fieldName] == undefined || target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function () { }
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function () {
							target[fieldName] = null;
							$timeout($scope.reportItemValueChanged);
							//TODO REMOVE COMMENT DANGEROUS $SCOPE $APPLY
							//$scope.$apply();
							return true;
						}
					}
				}
			});
		}

		/**
		 * Clear itemsFoundDescription
		 * @memberof ReportCtrl
		 */
		function clearItemsFoundDescription() {
			clearField($scope.report, "ItemsFoundDescription");
		}
		/**
		 * Clear itemsFoundAgent
		 * @memberof ReportCtrl
		 */
		function clearItemsFoundAgent() {
			clearField($scope.report, "ItemsFoundAgent");
		}
		/**
		 * Clear itemsFoundSignature
		 * @memberof ReportCtrl
		 */
		function clearItemsFoundSignature() {
			clearField($scope.report, "ItemsFoundSignature");
		}
		/**
		 * Clear UMDescription
		 * @memberof ReportCtrl
		 */
		function clearUMDescription() {
			clearField($scope.report, "UMDescription");
		}

		/**
		 * Clear UMAgent
		 * @memberof ReportCtrl
		 */
		function clearUMAgent() {
			clearField($scope.report, "UMAgent");
		}
		/**
		 * Clear UMSignature
		 * @memberof ReportCtrl
		 */
		function clearUMSignature() {
			clearField($scope.report, "UMSignature");
		}

		/**
		 * Clear LuggageDescription
		 * @memberof ReportCtrl
		 */
		function clearLuggageDescription() {
			clearField($scope.report, "LuggageDescription");
		}
		/**
		 * Clear WaterRemarks
		 * @memberof ReportCtrl
		 */
		function clearWaterRemarks() {
			clearField($scope.report, "WaterUpliftRemarks");
		}
		/**
		 * Clear Travel Value Remarks
		 * @memberof ReportCtrl
		 */
		function clearTravelValueRemarks() {
			clearField($scope.report, "TravelValueRemarks");
		}
		/**
 * Clear boarding times Remarks
 * @memberof ReportCtrl
 */
		function clearBoardingTimesRemarks() {
			clearField($scope.report, "BoardingTimesRemarks");
		}
		/**
* Clear disembarkation times Remarks
* @memberof ReportCtrl
*/
		function clearDisembarkationTimesRemarks() {
			clearField($scope.report, "DisembarkationTimesRemarks");
		}
		/**
		 * Clear Remarks
		 * @memberof ReportCtrl
		 */
		function clearRemarks() {
			clearField($scope.report, "Remarks");
		}
		/**
		 * Clear Crew Remarks
		 * @memberof ReportCtrl
		 */
		function clearCrewRemarks() {
			clearField($scope.report, "CrewRemarks");
		}
		/**
		 * Clear Various Item Remarks
		 * @memberof ReportCtrl
		 */
		function clearVariousItemRemarks(item) {
			if (item != null) {
				clearField(item, "ItemValue");
			}
		}
		/**
		 * Clear Various Item Remarks
		 * @memberof ReportCtrl
		 */
		function clearBarSealsPhotoRemarks(item) {
			if (item != null) {
				clearField(item, "PhotoRemarks");
			}
		}

		/**
		 * When the user types a value into a report item updates totals of the report
		 * @memberof ReportCtrl
		 */
		function reportItemValueChanged() {

			// update the report totals
			report.updateTotals();
		}

		/**
		 * Go to calendar and reset report
		 * @memberof ReportCtrl
		 */
		function cancelClicked() {
			//store report details
			var guid = report.ReportGuid;
			var status = report.Status;

			// delete the temp report
			CabinReportLocalEditFactory.deleteTempReport();

			//reuse guid if this was a new report
			if (status == 'pending')
				ReportGuidFactory.restoreGuid(report.ReportGuid);

			// set editing page to none
			SettingsMain.setEditingPage(null);

			// go to dashboard
			$location.path("/");
		}

		/**
		 * Show information about the save action
		 * @memberof ReportCtrl
		 * @param {string} state The action of the save completed or draft or discard
		 */
		function infoSaveOperation(state) {
			if (state == 'completed') {
				$scope.infosaveactiontype = state;
				$scope.infosaveaction = true;
			} else if (state == 'draft') {
				$scope.infosaveactiontype = state;
				$scope.infosaveaction = true
			} else if (state == 'discard') {
				$scope.infosaveactiontype = state;
				$scope.infosaveaction = true
			}

			$timeout(function () {
				$scope.infosaveaction = false;
			}, 5000);

		}

		/**
		 * Save Completed and Go to calendar
		 * @memberof ReportCtrl
		 */
		function saveClicked() {
			$scope.groomingReports = GroomingCategoriesFactory.collectGroomingReports($scope.groomingReportsByCrew)
			GroomingCategoriesFactory.saveGroomingReports($scope.groomingReportsByCrew);

			report.GroomingReports = $scope.groomingReports;
			
			report.updateTotals(); // make sure statuses/flags are up to date

			// AC 4.2: If any found property is Draft, the Cabin Report must be Draft
			if (report.HasFoundPropertyDraft) {
				report.Status = 'draft';
				report.saveReport();
				FlightFactory.updateFlightFromReport(report);
				CabinReportLocalEditFactory.deleteTempReport();
				CrewAssessmentFactory.updateCrewMembers(report.CCMSCrewPositions, report.Route, report.DutyDate, $scope.flight.FlightDate);
				SettingsMain.setEditingPage(null);
				infoSaveOperation(report.Status);
				return; // stay on the same page
			}

			// save the report
			report.Status = 'completed';
			report.saveReport();
			FlightFactory.updateFlightFromReport(report);

			// delete the temp report
			CabinReportLocalEditFactory.deleteTempReport();

			CrewAssessmentFactory.updateCrewMembers(report.CCMSCrewPositions, report.Route, report.DutyDate, $scope.flight.FlightDate);
			// set editing page to none
			SettingsMain.setEditingPage(null);
			infoSaveOperation(report.Status);

			// go to flight info
			$location.path('/flightinfo/' + report.FlightId);
		}
		/**
		 * Save Draft
		 * @memberof ReportCtrl
		 */
		function saveDraftClicked() {
			// save the report
			report.Status = 'draft';
			report.saveReport();
			FlightFactory.updateFlightFromReport(report);
			CrewAssessmentFactory.updateCrewMembers(report.CCMSCrewPositions, report.Route, report.DutyDate, $scope.flight.FlightDate);

			// delete the temp report
			CabinReportLocalEditFactory.deleteTempReport();

			// set editing page to none
			SettingsMain.setEditingPage(null);
			infoSaveOperation(report.Status);
			// go to dashboard
			// $location.path("/");
		}

		/**
		 * Delete Report
		 * @memberof ReportCtrl
		 */
		function deleteReportClicked() {
			var status = report.status;
			var title = "Warning";
			if (status == 'synched') {
				title = "Attention";
			}

			bootbox.dialog({
				message: "Please confirm that you wish to reset this Cabin Report.",
				title: "<strong>" + title + "<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function () { }
					},
					danger: {
						label: "Reset Cabin Report",
						className: "btn-warning",
						callback: function () {
							//store report details
							var guid = report.ReportGuid;
							var status = report.Status;

							// remove report from temp location and
							// possibly from permanent location
							CabinReportLocalEditFactory.deleteReport(report.ReportGuid);
							CrewAssessmentFactory.updateCrewMembers(report.CCMSCrewPositions, report.Route, report.DutyDate, $scope.flight.FlightDate);

							// delete the temp report
							CabinReportLocalEditFactory.deleteTempReport();


							FlightFactory.updateFlightFromReport(report);
							//reuse guid if this was  report was never sent to the server
							if (status == 'draft' || status == 'completed')
								ReportGuidFactory.restoreGuid(report.ReportGuid);

							// set editing page to none
							SettingsMain.setEditingPage(null);
							// next code moves user to main page
							$timeout(function () {
								if ($location.path() == "/report/temp") {
									$scope.openReport();
								} else {
									$route.reload();
								}
							})
						}
					}
				}
			});
		}

		/**
		 * increase row no of travel value
		 * @memberof ReportCtrl
		 */
		function plusTravelValueIncompleteRow() {
			if (!report.TravelValueIncompleteRow && report.TravelValueIncompleteRow != 0)
				report.TravelValueIncompleteRow = 0;
			else
				report.TravelValueIncompleteRow++;
			if (report.TravelValueIncompleteRow > 99) report.TravelValueIncompleteRow = 99;
			$scope.reportItemValueChanged();
		}

		/**
		 * decrease row no of travel value
		 * @memberof ReportCtrl
		 */
		function minusTravelValueIncompleteRow() {
			if (!report.TravelValueIncompleteRow && report.TravelValueIncompleteRow != 0)
				report.TravelValueIncompleteRow = 0;
			else
				report.TravelValueIncompleteRow--;
			if (report.TravelValueIncompleteRow < 0) report.TravelValueIncompleteRow = 0;
			$scope.reportItemValueChanged();
		}

		/**
		 * travel value changed
		 * @memberof ReportCtrl
		 */
		function reportTravelIncompleteChanged() {
			if (!report.TravelIncomplete) {
				report.TravelValueIncompleteRow = null;
				report.TravelValueIncompleteReason = null;
			}
			$scope.reportItemValueChanged();
		}

		/**
		 * When report changes run to update the item
		 * @memberof ReportCtrl
		 */
		function reportChanged(item) {

			// put preset comments
			if (item != null) {
				if (item.PresetComments != null) {
					if ((item.ItemValue == null) || (item.ItemValue == '')) {
						item.ItemValue = item.PresetComments;
					}
				}
			}

			// update the report totals
			report.updateTotals();

			// save the report to a temp place
			if (report.Status != 'synched')
				report.saveReportAsTemp();
		}

		//CCMS
		/**
		 * make the ccms positions
		 * @memberof ReportCtrl
		 */
		function reportCCMSPositions() {
			var reportCCMSPositions = new Array();
			var allCCMSPositions = CCMSFactory.getCCMSFromStorage();
			for (var i = 0; i < allCCMSPositions.length; i++) {

				// find the positions for this aircraft type
				if (allCCMSPositions[i].Aircraft == report.AcType) {

					for (var j = 0; j < allCCMSPositions[i].Positions.length; j++) {

						reportCCMSPositions.push(allCCMSPositions[i].Positions[j].Position);
					}
				}
			}
			return reportCCMSPositions;
		}


		/**
		 * Open confirmation modal for coping ccms 
		 * @memberof ReportCtrl
		 */
		function copyCcmsPositions() {
			bootbox.dialog({
				message: "Copy CCMS positions from previous leg?<br/><strong>Attention: </strong>Any current CCMS data will be overwritten",
				title: "<strong>CCMS Copy<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							copyCcmsPositionsFinal();
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});
		}

		/**
		 * copy positions from previous leg, to minimize input, normally, ac performs several legs in a row with the same crew, each at the same position on all legs   
		 * @memberof ReportCtrl
		 */
		function copyCcmsPositionsFinal() {
			if (report.CCMSCrewPositions == null || report.CCMSCrewPositions.length == 0) return;
			var guid = report.ReportGuid;
			var ac = report.AcTailNo;
			var dt = report.ScheduledDepartureDateUTC;
			var tm = report.ScheduledDepartureTimeUTC;
			var previousCcms = CabinReportLocalEditFactory.getPreviousCabinReportCcmsPositions(guid, ac, dt, tm);
			if (previousCcms != null && previousCcms.length > 0) {
				var posX, posI, found;
				//TODO: Special treatment for manual entries: Add new ones, update existing will data (Id, Initials, Name, Position, CCMS)
				//loop all previous report positions
				for (var i = 0; i < previousCcms.length; i++) {
					posI = previousCcms[i];
					found = false;
					//loop all report positions
					for (var x = 0; x < report.CCMSCrewPositions.length; x++) {
						posX = report.CCMSCrewPositions[x];
						//check for match
						if ((posX.CrewId != null && posX.CrewId != '' &&
							posI.CrewId != null && posI.CrewId != '' &&
							posX.CrewId == posI.CrewId) ||
							(posX.Initials != null && posX.Initials != '' &&
								posI.Initials != null && posI.Initials != '' &&
								posX.Initials == posI.Initials)) {
							//copy only if source has CCMS set
							if (posI.CCMS != null && posI.CCMS != '') {
								//old crew matched to current crew
								posX.CCMS = posI.CCMS;
								found = true;
								break;
							}
						}
					}
					//if old record was a manual entry and not found in the current crew list, add it also here as manual
					if (posI.IsManual == true && !found) {
						//console.debug(posI);
						//console.debug(report);
						report.CCMSCrewPositions.push(posI);
						//console.debug('Add code to copy manual crew member in this current report crew');
					}
				}
			}
			var s = '';
		}

		//UMNumber
		/**
		 * increases UM number 
		 * @memberof ReportCtrl
		 */
		function plusUMNumber() {
			report.UMNumber++;
			if (report.UMNumber > 200) report.UMNumber = 200;
			$scope.reportItemValueChanged();
		}
		/**
		 * decreases UM number 
		 * @memberof ReportCtrl
		 */
		function minusUMNumber() {
			report.UMNumber--;
			if (report.UMNumber < 0) report.UMNumber = 0;
			$scope.reportItemValueChanged();
		}
		/**
		 * Clear UM number 
		 * @memberof ReportCtrl
		 */
		function clearUMNumber() {
			report.UMNumber = 0;
			$scope.reportItemValueChanged();
		}

		//Luggage Number
		/**
		 * increases Luggage number 
		 * @memberof ReportCtrl
		 */
		function plusLuggageNumber() {
			report.LuggageNumber++;
			if (report.LuggageNumber > 100) report.LuggageNumber = 100;
			$scope.reportItemValueChanged();
		}
		/**
		 * decreases Luggage number 
		 * @memberof ReportCtrl
		 */
		function minusLuggageNumber() {
			report.LuggageNumber--;
			if (report.LuggageNumber < 0) report.LuggageNumber = 0;
			$scope.reportItemValueChanged();
		}
		/**
		 * Clear Luggage number 
		 * @memberof ReportCtrl
		 */
		function clearLuggageNumber() {
			report.LuggageNumber = 0;
			$scope.reportItemValueChanged();
		}
		// Bars Trolleys
		/**
		 * define open bar/trolley dialog function
		 * @memberof ReportCtrl
		 */
		function openBarTrolleyModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgBar.html',
				controller: 'BarTrolleyCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					bart: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.BarTrolleys.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}
					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new bar/trolley
		 * @memberof ReportCtrl
		 */
		function addNewBarTrolley() {
			try {
				openBarTrolleyModal(null);
			} catch (e) {
				LogService.debug("template barTrolley url (null)", e);
			}
		}

		/**
		 * edit bar/trolley
		 * @memberof ReportCtrl
		 */
		function editBarTrolley(bart) {
			try {
				openBarTrolleyModal(bart);
			} catch (e) {
				LogService.debug("template barTrolley url (bart)", e);
			}
		}

		/**
		* delete bar/trolley
		* @memberof ReportCtrl
		*/
		function deleteBarTrolley(bart) {

			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							BarTrolleyFactory.deleteFromList(bart, report.BarTrolleys);
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});

		}

		// function showOrHideBarTrolleyInputs() {
		// 	debugger;
		// 	$scope.showBarTrolleyUploadImage = $scope.report.BarTrolleys.filter(function (arg) { return filterPhotos(arg); }).length > 0 || $scope.report.BarTrolleys.length == 0;
		// 	$scope.showBarTrolleyInsertData = !$scope.report.BarTrolleys.filter(function (arg) { return filterPhotos(arg); }).length > 0 || $scope.report.BarTrolleys.length == 0;
		// }

		// function filterPhotos(arg) {
		// 	if (arg == null) {
		// 		return [];
		// 	}
		// 	else {
		// 		return arg.photos;
		// 	}
		// }

		// CCMS 
		/**
		 * define open ccms crew position dialog function
		 * @memberof ReportCtrl
		 */
		function openCCMSCrewPositionModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgCrew.html',
				controller: 'CCMSCrewPositionCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					crew: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null && result.Object != null) {
						//check if the same crew member already exists
						var unique = true;
						var errorField = null;
						if (result.Object.CrewId != null && result.Object.CrewId != '') {
							if (report.CCMSCrewPositions.filter(function (x) {
								return x.CrewId == result.Object.CrewId;
							}, true).length > 0) {
								unique = false;
								errorField = "id";
							}
						}
						if (result.Object.Initials != null && result.Object.Initials != '') {
							if (report.CCMSCrewPositions.filter(function (x) {
								return x.Initials.toUpperCase() == result.Object.Initials.toUpperCase();
							}, true).length > 0) {
								unique = false;
								errorField = "initials";
							}
						}
						if (unique) {
							if (result.isInsertMode) {
								report.CCMSCrewPositions.push(result.Object);
							} else {
								angular.extend(inputObject, result.Object);
							}

							$scope.reportItemValueChanged();
						} else {

							bootbox.alert("<h4>Warning</h4>Crew member with given " + errorField + ", already exists in this flight's crew and you may not add it again!");
						}
					}

				});
		}

		/**
		 * add new ccms crew positio
		 * @memberof ReportCtrl
		 */
		function addNewCCMSCrewPosition() {
			openCCMSCrewPositionModal(null);
		}
		//TODO REMOVE UNUSED
		/**
		 * edit ccms crew position
		 * @memberof ReportCtrl
		 */
		function editCCMSCrewPosition(crew) {
			openCCMSCrewPositionModal(crew);
		}

		/**
		 * delete ccms crew position
		 * @memberof ReportCtrl
		 */
		function deleteCCMSCrewPosition(crew) {

			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							CCMSCrewPositionFactory.deleteFromList(crew, report.CCMSCrewPositions);
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});

		}

		// Grooming issue modal
		$scope.openGroomingForm = function (crew) {
			if (!$scope.groomingReportsByCrew) {
				$scope.groomingReportsByCrew = GroomingCategoriesFactory.loadGroomingReports();
			}

			  // Fetch existing data or initialize default data
			  var existingData = $scope.groomingReportsByCrew[crew.CrewId];
			  var groomingData = existingData || groomingCategories.map(category => ({
				  Id: category.Id,
				  Label: category.Label,
				  Description: category.Description,
				  OrderNo: category.OrderNo,
				  UserInput: '' 
			  }));

			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgGroomingIssue.html',
				controller: 'GroomimgCategoriesModalCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					crewData: function () {
						return crew; 
					},
					groomingCategories: function () {
						return groomingData; 
					}
				}
			}).result.then(function (result) {
				if (result) {
				  // Save all categories for this crew, preserving the display of unfilled ones
				  $scope.groomingReportsByCrew[crew.CrewId] = result;

				  // Filter and log only completed categories
				  var completedCategories = result.filter(category => category.UserInput && category.UserInput.trim() !== '');
				}
			});
		};

		// Flight Detail
		function openFlightDetailModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgFlightDetail.html',
				controller: 'FlightDetailCtrl',
				size: 'md',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					fd: function () {
						return inputObject;
					}
				}
			}).result.then(function (result) {
				if (result != null) {
					angular.extend(inputObject, result.Object);
				}

				$scope.reportItemValueChanged();
			});
		}

		// First Aid Kit
		/**
		 * define open first aid kit dialog function
		 * @memberof ReportCtrl
		 */
		function openFirstAidKitModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgFirstAid.html',
				controller: 'FirstAidKitCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					fak: function () {
						return inputObject;
					},
					IsEMK: inputObject != null && inputObject.IsEMK
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.FirstAidKits.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new EMK first aid kit
		 * @memberof ReportCtrl
		 */
		function addNewEMKFirstAidKit() {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgFirstAid.html',
				controller: 'FirstAidKitCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					fak: null,
					IsEMK: true
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.FirstAidKits.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new first aid kit
		 * @memberof ReportCtrl
		 */
		function addNewFirstAidKit() {
			openFirstAidKitModal(null);
		}
		/**
		 * edit first aid kit
		 * @memberof ReportCtrl
		 */
		function editFirstAidKit(fak) {
			openFirstAidKitModal(fak);
		}
		/**
		 * delete first aid kit
		 * @memberof ReportCtrl
		 */
		function deleteFirstAidKit(fak) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							FirstAidKitFactory.deleteFromList(fak, report.FirstAidKits);
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});

		}

		// Medical Incidents
		/**
		 * define open medical incident dialog function
		 * @memberof ReportCtrl
		 */
		function openMedicalIncidentModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgMedical.html',
				controller: 'MedicalIncidentCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					med: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.MedicalIncidents.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}
					$scope.reportItemValueChanged();
				});

			//HACK FOR IOS:: Trying to sign, scrolls the modal dialog
			//following code, fixes that issue, but it is not a good looking solution
			$timeout(function () {
				if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
					$('.modal')
						.css({
							position: 'absolute',
							marginTop: $(window).scrollTop() + 'px',
							bottom: 'auto'
						});
					$('.modal-backdrop').css({
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: Math.max(
							document.body.scrollHeight, document.documentElement.scrollHeight,
							document.body.offsetHeight, document.documentElement.offsetHeight,
							document.body.clientHeight, document.documentElement.clientHeight
						) + 'px'
					});
				}
			}, 1000, false);
		}
		/**
		 * add new medical incident
		 * @memberof ReportCtrl
		 */
		function addNewMedicalIncident() {
			openMedicalIncidentModal(null);
		}

		/**
		 *  edit medical incident
		 * @memberof ReportCtrl
		 */
		function editMedicalIncident(med) {
			openMedicalIncidentModal(med);
		}

		/**
		 * delete medical incident
		 * @memberof ReportCtrl
		 */
		function deleteMedicalIncident(med) {

			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							MedicalIncidentFactory.deleteFromList(med, report.MedicalIncidents);
							$scope.reportItemValueChanged();
							$scope.$apply();
						}
					}
				}
			});

		}

		// Special meals
		/**
		 * define open special meal issue dialog function
		 * @memberof ReportCtrl
		 */
		function openSpecialMealIssueModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgSpecialMeal.html',
				controller: 'SpecialMealIssueCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					smi: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.SpecialMealIssues.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new special meal issue
		 * @memberof ReportCtrl
		 */
		function addNewSpecialMealIssue() {
			openSpecialMealIssueModal(null);
		}

		/**
		 * edit special meal issue
		 * @memberof ReportCtrl
		 */
		function editSpecialMealIssue(smi) {
			openSpecialMealIssueModal(smi);
		}

		/**
		 * delete special meal issue
		 * @memberof ReportCtrl
		 */
		function deleteSpecialMealIssue(smi) {

			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							SpecialMealIssueFactory.deleteFromList(smi, report.SpecialMealIssues);
							$timeout($scope.reportItemValueChanged);

						}
					}
				}
			});

		}

		// Supplies
		/**
		 * define open supply dialog function
		 * @memberof ReportCtrl
		 */
		function openSupplyModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgSupply.html',
				controller: 'SupplyCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					sup: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.Supplies.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new supply
		 * @memberof ReportCtrl
		 */
		function addNewSupply() {
			openSupplyModal(null);
		}

		/**
		 * edit supply
		 * @memberof ReportCtrl
		 */
		function editSupply(sup) {
			openSupplyModal(sup);
		}

		/**
		 * delete supply
		 * @memberof ReportCtrl
		 */
		function deleteSupply(sup) {

			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							SupplyFactory.deleteFromList(sup, report.Supplies);
							$timeout($scope.reportItemValueChanged);

						}
					}
				}
			});
		}


		// Seat Upgrades
		checkEligibleUpgrades();
		/**
		 * define open upgrade dialog function
		 * @memberof ReportCtrl
		 */
		function checkEligibleUpgrades() {
			var eligiblePassengers = [];

			var paxInfo = null;
			PaxInfoFactory.getPaxInfoFromStorage(report.FlightId, function (result) {
				paxInfo = result;

				if (paxInfo && paxInfo.Seatmap) {
					for (var i = 0; i < paxInfo.Seatmap.length; i++) {
						for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
							if (paxInfo.Seatmap[i].Columns[j].IsEligibleForUpgrade && paxInfo.Seatmap[i].Columns[j].Cabin == 'Y') {
								var alreadyUpgraded = false;
								for (var k = 0; k < report.UpgradedPassengers.length; k++) {
									if (report.UpgradedPassengers[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI &&
										report.UpgradedPassengers[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR &&
										report.UpgradedPassengers[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo) {
										alreadyUpgraded = true;
									}
								}
								if (!alreadyUpgraded) {
									eligiblePassengers.push(paxInfo.Seatmap[i].Columns[j]);
								}
							}
						}
					}
				}
				$scope.eligiblePassengers = eligiblePassengers.length;
			});
		}
		/**
		 * define open upgrade dialog function
		 * @memberof ReportCtrl
		 */
		function openUPGDModal(inputObject) {

			PaxInfoFactory.getPaxInfoFromStorage(report.FlightId, function (paxInfo) {

				$uibModal.open({
					templateUrl: 'views/Dialogs/dlgUPGD.html',
					controller: 'UPGDCtrl',
					size: 'lg',
					backdrop: 'static',
					keyboard: false,
					resolve: {
						upgradedPassenger: function () {
							return inputObject;
						},
						report: function () {
							return report;
						},
						paxInfo: function () {
							return paxInfo;
						}
					}
				})
					.result.then(function (result) {
						if (result != null) {
							if (result.isInsertMode) {
								report.UpgradedPassengers.push(result.Object);
							} else {
								angular.extend(inputObject, result.Object);
							}
						}
						checkEligibleUpgrades();
						$scope.reportItemValueChanged();
					});
			});
		}

		/**
		 * add new Upgrade
		 * @memberof ReportCtrl
		 */
		function addNewUPGD() {
			openUPGDModal(null);
		}

		/**
		 * edit Upgrade
		 * @memberof ReportCtrl
		 */
		function editUPGD(upgradedPassenger) {
			openUPGDModal(upgradedPassenger);
		}

		/**
		 * delete Upgrade
		 * @memberof ReportCtrl
		 */
		function deleteUPGD(upgradedPassenger) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							report.UpgradedPassengers = report.UpgradedPassengers.filter(function (p) {
								return p.OriginalSeatNo != upgradedPassenger.OriginalSeatNo && p.UCI != upgradedPassenger.UCI;
							});
							checkEligibleUpgrades();
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});
		}

		// Change Seat
		$scope.allPassengers = 0;
		getAllPasseengersCounter();

		function getAllPasseengersCounter() {
			PaxInfoFactory.getPaxInfoFromStorage(report.FlightId, function (result) {
				var paxInfo = result;
				var allPassengers = [];
				if (paxInfo) {
					for (var i = 0; i < paxInfo.Seatmap.length; i++) {
						for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {

							if (paxInfo.Seatmap[i].Columns[j].SeatNo && !paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
								allPassengers.push(paxInfo.Seatmap[i].Columns[j]);
							}
						}
					}
				}
				$scope.allPassengers = allPassengers.length;
			});
		}

		/**
		 * define open change seat dialog function
		 * @memberof ReportCtrl
		 */
		function openChangeSeatModal(inputObject) {

			PaxInfoFactory.getPaxInfoFromStorage(report.FlightId, function (paxInfo) {

				$uibModal.open({
					templateUrl: 'views/Dialogs/dlgSeatChange.html',
					controller: 'SeatChangeCtrl',
					size: 'lg',
					backdrop: 'static',
					keyboard: false,
					resolve: {
						changedSeat: function () {
							return inputObject;
						},
						report: function () {
							return report;
						},
						paxInfo: function () {
							return paxInfo;
						}
					}
				})
					.result.then(function (result) {
						if (result != null) {
							if (result.isInsertMode) {
								report.ChangedSeats.push(result.Object);
							} else {
								angular.extend(inputObject, result.Object);
							}
						}
						$scope.reportItemValueChanged();
					});
			});
		}

		/**
		 * add new seat change
		 * @memberof ReportCtrl
		 */
		function addNewChangedSeat() {
			openChangeSeatModal(null);
		}

		/**
		 * edit changed seat
		 * @memberof ReportCtrl
		 */
		function editChangedSeat(changedSeat) {
			openChangeSeatModal(changedSeat);
		}

		/**
		 * delete changed seat
		 * @memberof ReportCtrl
		 */
		function deleteChangedSeat(changedSeat) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							report.ChangedSeats = report.ChangedSeats.filter(function (p) {
								return p.OriginalSeatNo != changedSeat.OriginalSeatNo && p.UCI != changedSeat.UCI;
							});
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});
		}

		// Travel value seal 
		/**
		 * define open travel value seal dialog function
		 * @memberof ReportCtrl
		 */
		function openTravelValueSealModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgTravelValueSeal.html',
				controller: 'TravelValueSealCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					tvs: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.TravelValueSeals.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new travel value seal
		 * @memberof ReportCtrl
		 */
		function addNewTravelValueSeal() {
			openTravelValueSealModal(null);
		}

		/**
		 * edit travel value seal
		 * @memberof ReportCtrl
		 */
		function editTravelValueSeal(tvs) {
			openTravelValueSealModal(tvs);
		}
		/**
		 * delete travel value seal
		 * @memberof ReportCtrl
		 */
		function deleteTravelValueSeal(tvs) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							TravelValueSealFactory.deleteFromList(tvs, report.TravelValueSeals);
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});
		}

		// Incomplete In-flight Services 
		/**
		 * define open Incomplete In-flight Service dialog function
		 * @memberof ReportCtrl
		 */
		function openIncompleteServiceModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgIncompleteServices.html',
				controller: 'IncompleteServicesIssueCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					service: function () {
						return inputObject;
					},
					fleetId: function () {
						return flight.Fleet.Id;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.IncompleteServices.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * add new travel value seal
		 * @memberof ReportCtrl
		 */
		function addIncompleteService() {
			openIncompleteServiceModal(null);
		}

		/**
		 * edit travel value seal
		 * @memberof ReportCtrl
		 */
		function editIncompleteService(service) {
			openIncompleteServiceModal(service);
		}
		/**
		 * delete travel value seal
		 * @memberof ReportCtrl
		 */
		function deleteIncompleteService(service) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function () { }
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function () {
							IncompleteServicesIssueFactory.deleteFromList(service, report.IncompleteServices);
							$timeout($scope.reportItemValueChanged);
						}
					}
				}
			});
		}

		/**
		* add new additional feedback
		* @memberof ReportCtrl
		*/
		function addAdditionalFeedback() {
			openAdditionalFeedbackModal(null);
		}
		/**
		 * edit additional feedback
		 * @memberof ReportCtrl
		 */
		function editAdditionalFeedback(feedback) {
			openAdditionalFeedbackModal(feedback);
		}

		// First Aid Kit
		/**
		 * define open first aid kit dialog function
		 * @memberof ReportCtrl
		 */
		function openAdditionalFeedbackModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgAdditionalFeedback.html',
				controller: 'AdditionalFeedbackCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					feedback: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {
					if (result != null) {
						if (result.isInsertMode) {
							report.FirstAidKits.push(result.Object);
						} else {
							angular.extend(inputObject, result.Object);
						}
					}

					$scope.reportItemValueChanged();
				});
		}

		/**
		* add new found property
		* @memberof ReportCtrl
		*/
		function addNewFoundProperty() {
			openFoundPropertyModal(null, null);
		}

		/**
		 * edit found property
		 * @memberof ReportCtrl
		 */
		function editFoundProperty(item, index) {
			openFoundPropertyModal(item, index);
		}

			/**
		 * Returns true when a value is not null/undefined/empty after trimming.
		 */
		function hasNonEmptyValue(value) {
			return value != null && String(value).trim().length > 0;
		}

		/**
		 * Signature can be an array (strokes) or a string (base64).
		 */
		function hasSignatureValue(signature) {
			if (!signature) return false;

			if (Array.isArray(signature)) {
			return signature.length > 0;
		}

			return String(signature).trim().length > 0;
		}

		/**
		 * A Found Property entry is "completed" only when all mandatory fields are present.
		 */
		function isFoundPropertyCompleted(foundProperty) {
			return (
				!!foundProperty &&
				hasNonEmptyValue(foundProperty.Category) &&
				hasNonEmptyValue(foundProperty.AgentName) &&
				hasSignatureValue(foundProperty.Signature)
			);
		}

		/**
		 * Some report statuses should not be auto-mutated by draft logic.
		 */
		function isReportStatusLocked(reportStatus) {
			if (!reportStatus) return false;
			return String(reportStatus).toLowerCase() === "synched";
		}

		/**
		 * Ensures every Found Property has a valid Status (draft/completed).
		 * - Keeps explicit Status if valid.
		 * - Otherwise computes it based on mandatory fields.
		 */
		function getNormalizedFoundPropertyStatus(foundProperty) {
			var existingStatus = foundProperty && foundProperty.Status
				? String(foundProperty.Status).toLowerCase()
				: "";

			if (existingStatus === "draft" || existingStatus === "completed") {
				return existingStatus;
			}

		return isFoundPropertyCompleted(foundProperty) ? "completed" : "draft";
		}

		/**
		 * Updates report.Status based on Found Property statuses.
		 * Rule: If at least one Found Property is draft -> report becomes draft.
		 * Note: We do NOT auto-complete the report here. Save flow controls that.
		 */
		function updateReportStatusFromFoundProperties() {
			if (!$scope.report) return;

			if (isReportStatusLocked($scope.report.Status)) {
				return;
			}

			var foundProperties = $scope.report.FoundProperties || [];
			var hasAnyDraftFoundProperty = false;

			// Normalize statuses first (covers older entries without Status)
			foundProperties.forEach(function (fp) {
				fp.Status = getNormalizedFoundPropertyStatus(fp);
				if (fp.Status === "draft") {
				hasAnyDraftFoundProperty = true;
				}
			});

			if (hasAnyDraftFoundProperty) {
				$scope.report.Status = "draft";
			}
		}


		/**
		 * define open first aid kit dialog function
		 * @memberof ReportCtrl
		 */
		function openFoundPropertyModal(existingFoundProperty, existingIndex) {
			var isEditMode = !!existingFoundProperty;

			// Clone only when editing to avoid mutating the list item if user cancels
			var foundPropertyForModal = isEditMode ? angular.copy(existingFoundProperty) : {};

			$uibModal
				.open({
				templateUrl: "views/Dialogs/dlgFoundProperty.html",
				controller: "FoundPropertyCtrl",
				size: "lg",
				backdrop: "static",
				keyboard: false,
				resolve: {
					foundProperty: function () {
					return foundPropertyForModal;
					},
					openItemPhotosModal: function () {
					return openItemPhotosModal;
					},
				},
				})
				.result.then(function (returnedFoundProperty) {
					$scope.report.FoundProperties = $scope.report.FoundProperties || [];

					// Normalize Status (modal may have set Status explicitly)
					returnedFoundProperty.Status = getNormalizedFoundPropertyStatus(returnedFoundProperty);
				if (isEditMode) {
					$scope.report.FoundProperties[existingIndex] = returnedFoundProperty;
				} else {
					$scope.report.FoundProperties.push(returnedFoundProperty);
				}

				updateReportStatusFromFoundProperties();

				$scope.report.updateTotals();

				if ($scope.report.Status !== 'synched') {
					$scope.report.saveReport();
					FlightFactory.updateFlightFromReport($scope.report); 
				}
				$timeout($scope.reportItemValueChanged);
				})
				.catch(function (dismissReason) {
				});
			}
		/**
		 * delete found property
		 * @memberof ReportCtrl
		 */
		function deleteFoundProperty(foundPropertyToDelete) {
			bootbox.dialog({
				message: "Are you sure you want to delete this record?",
				title: "<strong>Delete record<strong>",
				buttons: {
				no: {
					label: "No",
					className: "btn-default",
					callback: function () { }
				},
				yes: {
					label: "Yes",
					className: "btn-warning",
					callback: function () {
					$scope.report.FoundProperties = $scope.report.FoundProperties || [];

					var index = $scope.report.FoundProperties.indexOf(foundPropertyToDelete);
					if (index !== -1) {
						$scope.report.FoundProperties.splice(index, 1);
					}

					updateReportStatusFromFoundProperties();

					$scope.report.updateTotals();

					if ($scope.report.Status !== 'synched') {
						$scope.report.saveReport();
						FlightFactory.updateFlightFromReport($scope.report);
					}
					$timeout($scope.reportItemValueChanged);
					}
				}
				}
			});
		}

		//TimePicker times - convert to Date UTC
		$scope.BoardingDisembarkationTimes = {
			FirstPaxDisembarkationTime: $scope.report.FirstPaxDisembarkationTime ? new Date($scope.report.FirstPaxDisembarkationTime).toUTC() : null,
			LastPaxDisembarkationTime: $scope.report.LastPaxDisembarkationTime ? new Date($scope.report.LastPaxDisembarkationTime).toUTC() : null,
			FirstPaxTime: $scope.report.FirstPaxTime ? new Date($scope.report.FirstPaxTime).toUTC() : null,
			LastPaxTime: $scope.report.LastPaxTime ? new Date($scope.report.LastPaxTime).toUTC() : null,
		};

		// Boarding times
		var hasFirstTime = false;
		var hasLastTime = false;
		$scope.FirstPaxGetTimeUTC = firstPaxGetTimeUTC;
		$scope.LastPaxGetTimeUTC = lastPaxGetTimeUTC;
		$scope.firstPaxTimeChanged = firstPaxTimeChanged;
		$scope.lastPaxTimeChanged = lastPaxTimeChanged;

		function firstPaxTimeChanged() {
			if (!hasFirstTime) {
				firstPaxGetTimeUTC();
				hasFirstTime = true;
			}
			else {
				//From timepicker(date) to report(moment)
				var dateObj = new Date($scope.BoardingDisembarkationTimes.FirstPaxTime).fromUTC();
				$scope.report.FirstPaxTime = moment(dateObj);
			}
		}
		function lastPaxTimeChanged() {
			if (!hasLastTime) {
				lastPaxGetTimeUTC();
				hasLastTime = true;
			}
			else {
				//From timepicker(date) to report(moment)
				var dateObj = new Date($scope.BoardingDisembarkationTimes.LastPaxTime).fromUTC();
				$scope.report.LastPaxTime = moment(dateObj);
			}
		}

		function firstPaxGetTimeUTC() {
			$scope.report.FirstPaxTime = moment.utc();

			//convert to date for uib timepicker
			$scope.BoardingDisembarkationTimes.FirstPaxTime = moment($scope.report.FirstPaxTime).toDate().toUTC();

			saveDraftClicked();

		}
		function lastPaxGetTimeUTC() {
			$scope.report.LastPaxTime = moment.utc();

			//convert to date for uib timepicker
			$scope.BoardingDisembarkationTimes.LastPaxTime = moment($scope.report.LastPaxTime).toDate().toUTC();
			saveDraftClicked();
		}

		// Disembarkation times
		var hasFirstDisembarkationTime = false;
		var hasLastDisembarkationTime = false;
		$scope.FirstPaxGetDisembarkationTimeUTC = firstPaxGetDisembarkationTimeUTC;
		$scope.LastPaxGetDisembarkationTimeUTC = lastPaxGetDisembarkationTimeUTC;
		$scope.firstPaxDisembarkationTimeChanged = firstPaxDisembarkationTimeChanged;
		$scope.lastPaxDisembarkationTimeChanged = lastPaxDisembarkationTimeChanged;

		function firstPaxDisembarkationTimeChanged() {
			if (!hasFirstDisembarkationTime) {
				firstPaxGetDisembarkationTimeUTC();
				hasFirstDisembarkationTime = true;
			}
			else {
				//From timepicker(date) to report(moment)
				var dateObj = new Date($scope.BoardingDisembarkationTimes.FirstPaxDisembarkationTime).fromUTC();
				$scope.report.FirstPaxDisembarkationTime = moment(dateObj);
			}
		}

		function lastPaxDisembarkationTimeChanged() {
			if (!hasLastDisembarkationTime) {
				lastPaxGetDisembarkationTimeUTC();
				hasLastDisembarkationTime = true;
			}
			else {
				//From timepicker(date) to report(moment)
				var dateObj = new Date($scope.BoardingDisembarkationTimes.LastPaxDisembarkationTime).fromUTC();
				$scope.report.LastPaxDisembarkationTime = moment(dateObj);
			}
		}

		function firstPaxGetDisembarkationTimeUTC() {
			//apply moment time in report
			$scope.report.FirstPaxDisembarkationTime = moment.utc();

			//convert to date for uib timepicker
			$scope.BoardingDisembarkationTimes.FirstPaxDisembarkationTime = moment($scope.report.FirstPaxDisembarkationTime).toDate().toUTC();

			saveDraftClicked();

		}
		function lastPaxGetDisembarkationTimeUTC() {
			$scope.report.LastPaxDisembarkationTime = moment.utc();

			//convert to date for uib timepicker
			$scope.BoardingDisembarkationTimes.LastPaxDisembarkationTime = moment($scope.report.LastPaxDisembarkationTime).toDate().toUTC();

			saveDraftClicked();
		}


		//Item Photos

		/**
		 * define open item photos dialog function
		 * @memberof ReportCtrl
		 */
		function openItemPhotosModal(inputObject) {
			$uibModal.open({
				templateUrl: 'views/Dialogs/dlgItemPhotos.html',
				controller: 'ItemPhotosCtrl',
				size: 'md',
				backdrop: 'static',
				keyboard: false,
				resolve: {
					item: function () {
						return inputObject;
					}
				}
			})
				.result.then(function (result) {

					$scope.reportItemValueChanged();
				});
		}

		/**
		 * attach Photo On Various Item
		 * @memberof ReportCtrl
		 */
		function attachPhotoOnVariousItem(item) {
			openItemPhotosModal(item);
		}

		/**
		* attach Photo On Various Item
		* @memberof ReportCtrl
		*/
		function attachPhotoOnBarTrolley(item) {

			if (item == undefined) {
				var x = BarTrolleyFactory.createNew();
				item = x;
				report.BarTrolleys.push(item);
			}
			openItemPhotosModal(item);
		}

		$scope.autoAdjustTarget = null;
		$scope.autoAdjustTimer = null;
		$scope.autoAdjustElement = function (element) {
			if (element) {
				autoAdjustTextarea(element);
			}
		}

		$scope.autoAdjustRun = function () {
			var t = $scope.autoAdjustTarget;
			$scope.autoAdjustElement(t);
			$scope.autoAdjustTarget = null;
			$scope.autoAdjustTimer = null;

			// also, update the report and save it to a temp place
			report.updateTotals();
			if (report.Status != 'synched')
				report.saveReportAsTemp();
		}

		$scope.adjustTextarea = function ($event) {
			// $event.keyCode = 13
			// performing adjusts using a timer, to minimize times it executes, and
			// make it faster on ipad2
			if ($scope.autoAdjustTimer != null) {
				clearTimeout($scope.autoAdjustTimer);
				// old object pending... execute its adjustment and then plan new
				// object's adjustment
				if ($event.target != $scope.autoAdjustTarget) {
					$scope.autoAdjustRun();
				}
			}
			$scope.autoAdjustTarget = $event.target;
			$scope.autoAdjustTimer = setTimeout($scope.autoAdjustRun, 500);
		}

		/**
		* It handles the cabin report when u want to navigate to another view
		* @memberof CabinReports
		* @param {Object} report input the cabin report  
		*/
		function handleIfReport(report) {
			if ($scope.state == 'report') {
				if (report == null) {
					report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(report.FlightId);
				}

				// delete the temp report
				CabinReportLocalEditFactory.deleteTempReport();

				//reuse guid if this was a new report
				if (report.Status == 'pending')
					ReportGuidFactory.restoreGuid(report.ReportGuid);
			}
		}

		$scope.BarSealsImage = [];
		$scope.BarSealsImageRemarks;

		//-- Flight Orders - Shop In The Cloud
		function updateOrderStatus(order){
			report.updateTotals();
			//report.saveReport();
		}
		/**
		* attach Photo On Flight Order
		* @memberof ReportCtrl
		*/
		function attachPhotoOnFlightOrder(item) {
			openItemPhotosModal(item);
		}
		/**
		 * Clear Flight Order Feedback
		 * @memberof ReportCtrl
		 */
		function clearFlightOrderFeedback(item) {
			if (item != null) {
				clearField(item, "feedback");
			}
		}
	}

})();
